export default class PiingConnectionError extends Error {
  constructor(message) {
    super(message);
    this.name = 'PiingConnectionError';
  }
}